import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    bancoMovimientoId: 0,
    presupuestosInternos: [],
    importeTransferencia: 0,
    importeAsignado: 0,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, bancoMovimientoId) {
        state.bancoMovimientoId = bancoMovimientoId;
        state.presupuestosInternos = [];
        state.importeTransferencia = 0;
        state.importeAsignado = 0;
        state.rowVersion = null;
    },
    'SET_TRANSFERENCIA_PREMIOS'(state, transferenciaPremios) {
        state.presupuestosInternos = transferenciaPremios.presupuestosInternos;
        state.importeTransferencia = transferenciaPremios.importe;
        state.rowVersion = transferenciaPremios.rowVersion;

        if (state.presupuestosInternos.lenght != 0) {
            state.importeAsignado = state.presupuestosInternos
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeAsignado = 0;
        }
    },

    'SET_ASIGNACION_PRESUPUESTO' (state, presupuestoInterno) {
        state.presupuestosInternos.push(presupuestoInterno);

        if (state.presupuestosInternos.lenght != 0) {
            state.importeAsignado = state.presupuestosInternos
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeAsignado = 0;
        }
    },
    'DELETE_ASIGNACION_PRESUPUESTO' (state, presupuestoInterno) {
        let itemKey = state.presupuestosInternos
            .findIndex(item => item == presupuestoInterno);

        if (itemKey != -1) {
            state.presupuestosInternos.splice(itemKey, 1);
        }

        if (state.presupuestosInternos.lenght != 0) {
            state.importeAsignado = state.presupuestosInternos
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeAsignado = 0;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar: ( { commit }, bancoMovimientoId ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', bancoMovimientoId);

            /* Recuperamos la información de las asignaciones existentes */
            apiAxios.get('bancosmovimientos/' + bancoMovimientoId + '/transferencia-premios')
                .then(res => {
                    commit('SET_TRANSFERENCIA_PREMIOS', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state }  ) {
        return new Promise((resolve, reject) => {
            let presupuestosInternos = [];
            state.presupuestosInternos.forEach(presupuestoInterno => {
                presupuestosInternos.push({
                    presupuestoInternoId: presupuestoInterno.presupuestoInternoId,
                    importe: presupuestoInterno.importe
                })
            });
            
            let bancoMovimiento= {
                presupuestosInternos: presupuestosInternos,
                rowVersion: state.rowVersion
            };

            apiAxios.post('bancosmovimientos/' + state.bancoMovimientoId + '/transferencia-premios-asignacion', bancoMovimiento)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setAsignacionPresupuesto: ( { commit }, presupuestoInterno ) => {
        commit('SET_ASIGNACION_PRESUPUESTO', presupuestoInterno);
    },
    deleteAsignacionPresupuesto: ( { commit }, presupuestoInterno ) => {
        commit('DELETE_ASIGNACION_PRESUPUESTO', presupuestoInterno);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}